module.exports = __webpack_public_path__ + "static/media/2_7.bca5be7e.png";